import React from 'react';
import css from './CustomFooter.module.css';
import { NamedLink } from '../../components';
import IconLogo from '../../components/IconLogo/IconLogo';
import { useIntl } from 'react-intl';
import SocialLinks from '../TopbarContainer/Topbar/TopbarDesktop/CustomLinksMenu/SocialLinks';
const CustomFooter = () => {
  const intl = useIntl();
  return (
    <div className={css.customFooterBlock}>
      <div className={css.footerInnerLinks}>
        <div className={css.footerLinks}>
          <div>
            <NamedLink className={css.finishListingDraftLink} name="AboutUs">
              {intl.formatMessage({ id: 'Footer.LinkAboutUs' })}
            </NamedLink>
          </div>
          <div>
            <NamedLink className={css.finishListingDraftLink} name="ContactUsPage">
              {intl.formatMessage({ id: 'Footer.LinkContactUs' })}
            </NamedLink>
          </div>
          <div>
            <NamedLink className={css.finishListingDraftLink} name="ImprintPage">
              {intl.formatMessage({ id: 'Footer.LinkImprint' })}
            </NamedLink>
          </div>
          <div>
            <NamedLink className={css.finishListingDraftLink} name="AffiliatePage">
              {intl.formatMessage({ id: 'Footer.LinkAffiliate' })}
            </NamedLink>
          </div>
        </div>

        <div className={css.footerLogoBlock}>
          <IconLogo />
          <p>new owner for any business</p>
        </div>

        <div className={css.footerSocialLinks}>
          <SocialLinks />
        </div>
      </div>
    </div>
  );
};

export default CustomFooter;
